export const cyr = {
  accept: 'У реду',
  reject: 'Откажи',
  dayNames: [
    'Недеља',
    'Понедељак',
    'Уторак',
    'Среда',
    'Четвртак',
    'Петак',
    'Субота',
  ],
  dayNamesShort: ['Нед', 'Пон', 'Уто', 'Сре', 'Чет', 'Пет', 'Суб'],
  monthNames: [
    'Јануар',
    'Фебруар',
    'Март',
    'Април',
    'Мај',
    'Јун',
    'Јул',
    'Август',
    'Септембар',
    'Октобар',
    'Новембар',
    'Децембар',
  ],
  monthNamesShort: [
    'Јан',
    'Феб',
    'Мар',
    'Апр',
    'Мај',
    'Јун',
    'Јул',
    'Авг',
    'Сеп',
    'Окт',
    'Нов',
    'Дец',
  ],
  today: 'Данас',
  clear: 'Обриши',
  dateFormat: 'dd.mm.yy',
  firstDayOfWeek: 1,
  emptyMessage: 'Нема података',

  // 🌐 MultiSelect / Dropdown
  choose: 'Изабери',
  filter: 'Филтрирај',
  close: 'Затвори',
  apply: 'Примени',
  selectAll: 'Изабери све',
  unselectAll: 'Поништи избор',
  emptyFilterMessage: 'Нема резултата',
  emptySelectionMessage: 'Ништа није изабрано',
  selectedItemsLabel: '{0} ставки изабране',
  maxSelectedLabels: '{0} ставке изабране',
  chipSelected: '{0} изабрано',

  first: 'Прва',
  last: 'Последња',
  next: 'Следећа',
  previous: 'Претходна',
  rowsPerPage: 'Редова по страни',
  currentPageReport: '{first}–{last} од {totalRecords}',
};
